import { Component, OnInit, Input } from "@angular/core";

import { CTAButtonLayout } from "../cta-button-layout";
import {
	CtaButtonLayoutInternetContractLengthContext,
	DiscountDetails,
} from "./cta-button-layout-internet-contract-length.models";

@Component({
    selector: "dodo-cta-button-layout-internet-contract-length",
    templateUrl: "./cta-button-layout-internet-contract-length.component.html",
    styleUrls: ["./cta-button-layout-internet-contract-length.component.scss"],
    standalone: false
})
export class CtaButtonLayoutInternetContractLengthComponent
	extends CTAButtonLayout
	implements OnInit {
	@Input() id: number;
	@Input() title: string;
	@Input() iconImage: string;
	@Input() descriptions: string[];

	@Input() marketing: {
		text: string;
		textDecoration: string;
	};

	@Input() set context(ctx: CtaButtonLayoutInternetContractLengthContext) {
		if (ctx) {
			this.__updatePropertyFromContext(ctx);
		}
	}

	@Input() set discount(descriptions: string[]) {
		if (descriptions) {
			this.descriptions = descriptions;
		}
	}

	set layoutContext(ctx: CtaButtonLayoutInternetContractLengthContext) {
		if (ctx) {
			this.__updatePropertyFromContext(ctx);
		}
	}

	private __updatePropertyFromContext(
		ctx: CtaButtonLayoutInternetContractLengthContext
	) {
		this.id = this.id || ctx.id;
		this.title = this.title || ctx.title;
		this.iconImage = this.iconImage || ctx.iconImage;
		this.descriptions = this.descriptions || ctx.descriptions;
		this.marketing = this.marketing || ctx.marketing;
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
